export const inventoryID = (id = null) => {
  // Define inventory ID
  if (MK.page && MK.page.ids && MK.page.ids.inventory) {
    id = MK.page.ids && MK.page.ids.inventory
  } else if (MK.page && MK.page.type === 'category' || MK.page.type === 'root') {
    id = MK.page.id
  } else if (MK.page && MK.page.type === 'attribute' && MK.page.ids && MK.page.ids.parent) {
    id = MK.page.ids.parent
  } else {
    throw new Error('!!! ERROR (load.inventory) Unable to determine inventory ID.')
  }

  return id
}
